import axios from 'axios';

import { StatePlaceholder } from '../cdl/StatePlaceholder/StatePlaceholder';
import { Text } from '../cdl/Text/Text';
import { formatDateTime } from '../common/helpers/formatDateTime.helper';
import { translate } from '../common/helpers/translate.helper';
import { IconAlertTriangle } from '../common/icons/cdl/AlertTriangle';
import { IconDatabaseOff } from '../common/icons/cdl/DatabaseOff';
import { LoadingIndicator } from '../common/LoadingIndicator/LoadingIndicator';
import { Box } from '../common/ui/Box';

import { OnePortProductCatalogueTable } from './OnePortProductCatalogueTable';
import { useOnePortProductCatalogue } from './useOnePortProductCatalogue';

export const OnePortProductCatalogueSection = () => {
    const catalogueQuery = useOnePortProductCatalogue();

    if (catalogueQuery.isPending) {
        return <LoadingIndicator />;
    }

    if (catalogueQuery.isError) {
        const isMissing = axios.isAxiosError(catalogueQuery.error) && catalogueQuery.error.response?.status === 404;
        return (
            <Box display="flex" justifyContent="center" paddingY={64}>
                <StatePlaceholder
                    Icon={isMissing ? IconDatabaseOff : IconAlertTriangle}
                    title={translate(
                        isMissing
                            ? 'integrationsOverview.productCatalogue.missing.title'
                            : 'integrationsOverview.productCatalogue.error.title'
                    )}
                    description={translate(
                        isMissing
                            ? 'integrationsOverview.productCatalogue.missing.description'
                            : 'integrationsOverview.productCatalogue.error.description'
                    )}
                />
            </Box>
        );
    }

    return (
        <Box display="flex" flexDirection="column" gap={16}>
            <Box display="flex" alignItems="baseline" justifyContent="space-between" gap={16} flexWrap="wrap">
                <Text variant="title" as="h2">
                    {translate('integrationsOverview.productCatalogue.title')}
                </Text>
                <Text variant="small" color="foreground.muted">
                    {translate('integrationsOverview.productCatalogue.metadata', {
                        updatedAt: formatDateTime({ date: catalogueQuery.data.fetchedAt }),
                        productCount: catalogueQuery.data.productCount.toString(),
                    })}
                </Text>
            </Box>
            <OnePortProductCatalogueTable products={catalogueQuery.data.products} />
        </Box>
    );
};
